import React, { useState } from 'react';
import Select from 'react-select';

const ShippingDtlsTab = () => {
const [disableHawbIssuedBy, setDisableHawbIssuedBy] = useState(true);

// Placeholder options (replace these with actual data)
const joborderOptions = [];
const agentOptions = [];
const customerOptions = [];
const quotationOptions = [];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="card px-3 py-2">
                    <div className="row">

                        <div className="col-md-6 mt-2 d-flex flex-column gap-1 align-items-baseline">

                            <label className="form-label   text-nowrap d-flex flex-grow-1 mb-0">AWB Issued
                                By</label>
                            <select name="" id="" disabled={disableHawbIssuedBy}
                                className='form-control form-control-sm'>
                                <option value="" selected> </option>
                            </select>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        AWB No.
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select className=' custom-selector ' /> </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Execution Place
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" name='order_no' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    No. of Packages
                                </label>
                                <div className="d-flex flex-row gap-1 ">
                                    <input type="number" className="form-control form-control-sm "
                                        name='search_by' placeholder='0' />
                                    <div className="icon-forms mb-3 mb-sm-0 flex-grow-1 w-100">
                                        <Select className='custom-selector flex-grow-1 ' />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label mb-0'>
                                    Total Inner Packages
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <input type="number" className="form-control form-control-sm" placeholder='0' />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Total Gross Weight
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="number" className="form-control form-control-sm"
                                            placeholder='0.000' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Unit
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select className='custom-selector' defaultValue="KGS" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Total Net Weight
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="number" className="form-control form-control-sm"
                                            placeholder='0.000' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Unit
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select className='custom-selector' defaultValue="KGS" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Total Volume
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="number" className="form-control form-control-sm"
                                            placeholder='0.000' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Unit
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select className='custom-selector' defaultValue="CBM" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Volume Weight
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="number" className="form-control form-control-sm"
                                            placeholder='0.000' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Unit
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select className='custom-selector' defaultValue="KGS" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Total Charged Weight
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="number" className="form-control form-control-sm"
                                            placeholder='0.000' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Unit
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select className='custom-selector' defaultValue="KGS" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <hr className='mt-4' />
                    <div className="row">
                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Place of Receipt
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Loading Port
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Discharge Port
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Place of Delivery
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Airline
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Flight No.
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Freight
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select className="form-control form-control-sm">
                                    <option>Prepaid</option>
                                    <option>Collect</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Other Charge
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select className="form-control form-control-sm">
                                    <option>Prepaid</option>
                                    <option>Collect</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Freight Currency
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select className="form-control form-control-sm">
                                    <option>INR</option>
                                    <option>USD</option>
                                    <option>EUR</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Dest Agent Profit %
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0 d-flex align-items-center">
                                <input type="number" className="form-control form-control-sm" placeholder='0.00' />
                                <span className="ms-2">%</span>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Trade Lane
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Terminal Operator
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Dest Agent Ref.
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Contract
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Co-Load Type
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select className="form-control form-control-sm">
                                    <option>Not Applicable</option>
                                    <option>Applicable</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label htmlFor="" className='form-label mb-0'>
                                Agent Name
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Agent AWB No/Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" />
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                        <div className=' d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" />
                                    </div>
                                </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default ShippingDtlsTab